import React from 'react';

const TableTransfer = ({ currency, bankAccountId }) => {
  // This table will be ready for API integration
  // Currently showing empty state with proper column structure

  return (
    <div>
      <div className="table-responsive">
        <table className="table table-sm table-borderless">
          <thead>
            <tr>
              <th className="tableheader-txt">Voucher ID</th>
              <th className="tableheader-txt">Date</th>
              <th className="tableheader-txt">HGO</th>
              <th className="tableheader-txt">Companies</th>
              <th className="tableheader-txt">Total Balance</th>
              <th className="tableheader-txt">Shares</th>
            </tr>
          </thead>
          <tbody>
            {/* Empty state - ready for data */}
            <tr>
              <td colSpan="6" className="tabledata-txt text-center py-5 text-muted">
                No transfer data available
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableTransfer;
